import { useMutation, useQueryClient } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { toastErrorApi, toastExito } from "@/lib/toast";
import {
  editarConfiguracion,
  restablecerConfiguracion,
} from "../services/configuraciones-service";

export function useEditarConfiguracion(opts?: { onGuardado?: () => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ clave, valor }: { clave: string; valor: string }) =>
      editarConfiguracion(clave, valor),
    onSuccess: (cfg) => {
      toastExito({
        title: `Configuración ${cfg.clave} guardada`,
        message: "El nuevo valor está activo (algunos ajustes requieren reiniciar).",
      });
      void qc.invalidateQueries({ queryKey: qk.adminConfiguraciones });
      opts?.onGuardado?.();
    },
    onError: toastErrorApi,
  });
}

export function useRestablecerConfiguracion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (clave: string) => restablecerConfiguracion(clave),
    onSuccess: (cfg) => {
      toastExito({ title: `Configuración ${cfg.clave} restablecida`, message: "Se volvió al valor por defecto." });
      void qc.invalidateQueries({ queryKey: qk.adminConfiguraciones });
    },
    onError: toastErrorApi,
  });
}
